import { render, staticRenderFns } from "./calyrafit-collections.vue?vue&type=template&id=4cb76154&scoped=true&"
import script from "./calyrafit-collections.vue?vue&type=script&lang=js&"
export * from "./calyrafit-collections.vue?vue&type=script&lang=js&"
import style0 from "./calyrafit-collections.vue?vue&type=style&index=0&id=4cb76154&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb76154",
  null
  
)

export default component.exports